import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import { IAccount, INavigationItem } from '@share/common-types';

import PlaceHolder from '@assets/images/inclusives/all-inclusives-submit-request-card-img.jpg';

import './style.scss';

interface IProps {
  items: INavigationItem[];
  isMLM: boolean;
  account: IAccount;
}

const ONE = 1;

export class DailyBenefitsItems extends Component<IProps> {
  render(): React.ReactNode {
    const { items, isMLM, account } = this.props;

    let styles: any = account?.mainBorderColor ? { borderColor: account?.mainBorderColor } : {};
    styles = account?.mainBorderRadius ? { ...styles, borderRadius: `${account?.mainBorderRadius}px` } : { ...styles };
  
    return (
      <div className="items-wrapper">
        <div className="items-wrapper__wrapper">
          <h2 className="items-wrapper__heading secondary-font">
            <FormattedMessage id="daily.benefits.items.heading" />
          </h2>
          <div className="items-wrapper__items">
            {items
              ? items.filter(({ title }) => !isMLM || !title.includes('Active')).map(({ imageUrl, title, description, url }) => (
                  <a
                    key={title}
                    className={`items-wrapper__item hover ${items.length === ONE ? 'span' : ''}`}
                    href={url}
                    target="__blank"
                    rel="noreferrer"
                    style={styles}
                  >
                    <img
                      className={`items-wrapper__item-image ${items.length === ONE ? 'span' : ''}`}
                      src={!imageUrl ? PlaceHolder : imageUrl}
                      style={styles}
                    />
                    <div className="items-wrapper__item-text-wrapper">
                      <h2 className="items-wrapper__item-heading"><FormattedMessage id={title} /></h2>
                      <p className="items-wrapper__item-paragraph"><FormattedMessage id={description} /></p>
                    </div>
                  </a>
                ))
              : null}
          </div>
        </div>
      </div>
    );
  }
}
